import { ServicepartnerFilterField } from "../types/ServicepartnerFilterField.interface";

export const servicepartnerFilterFields: ServicepartnerFilterField[] = [
  {
    name: "name",
    label: "Naam hersteller",
    type: "text",
    placeholder: "Rumble Hersteller",
  },
];
